import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AssignmentsHub from './Assignments/AssignmentsHub';
import LearningTaskCard from './Assignments/LearningTaskCard';
import AssignmentGradingGrid from './Assignments/AssignmentGradingGrid';
import AssignmentScoringPrintout from './Assignments/AssignmentScoringPrintout';
import CreateLearningTask from './Assignments/CreateLearningTask';

export default function AssignmentsPage() {
  return (
    <Routes>
      <Route index element={<AssignmentsHub />} />
      <Route path="new" element={<CreateLearningTask />} />
      <Route path="create" element={<CreateLearningTask />} />
      <Route path=":assignmentId/edit" element={<LearningTaskCard />} />
      <Route path=":assignmentId" element={<AssignmentGradingGrid />} />
      <Route path=":assignmentId/print" element={<AssignmentScoringPrintout />} />
    </Routes>
  );
}
